// Modules
import { Link } from 'react-router';
import { connect } from 'react-redux';
import Promise from 'bluebird';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import { Page, PageHeader, PageContent, ActionSection } from 'components/page';
import { SVGButton } from 'components/widgets/buttons';
import { SortableTH } from 'components/content-containers/tables';
import { Table } from 'components/content-containers/tables/tables';
import { alerts } from 'modules/alerts/actions';
import { didQueryUpdate } from 'utils/filter-utils';
import CompanyNickname from 'components/models/company/company-nickname';
import Filters from 'modules/filters/filters';
import Pager from 'components/widgets/pager/pager';
import SVG from 'components/widgets/icons/svg';
import ShortDate from 'components/widgets/dates/short-date';
import Watch from 'services/data/watch';

import * as actions from './store/actions';


// Component
class Watches extends React.Component {
  static propTypes = {
    watches: PropTypes.array,
    fetching: PropTypes.bool,
    count: PropTypes.number,
    query: PropTypes.object
  };

  constructor() {
    super();

    this.search = this.search.bind(this);

    this.filterConfig = {
      basic: ['company'],
      advanced: [
        ['company', 'team', 'date']
      ],
      defaults: {
        date: { max: moment().endOf('month').toDate() }
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (didQueryUpdate(nextProps, this.props)) this.search(nextProps.query);
  }

  componentWillUnmount() {
    actions.set({ count: null });
  }

  archiveWatch(watch) {
    const watches = _.reject(this.props.watches, { id: watch.id });

    return Watch.update({ id: watch.id, status: 'Archived' })
      .then(() => actions.set({ watches }));
  }

  search(query) {
    actions.set({ fetching: true });
    const fullQuery = Watch.formatQuery(query || this.props.query);

    return Promise.props({
      watches: Watch.find(fullQuery),
      count: Watch.count({ where: fullQuery.where })
    })
      .then((response) => {
        actions.set({ fetching: false, watches: response.watches, count: response.count });
      })
      .catch(alerts.catchError);
  }

  render() {
    const { watches = [], count = 0, fetching } = this.props;

    return (
      <Page>
        <PageHeader title="Watches">
          <ActionSection>
            <Filters config={this.filterConfig} />
          </ActionSection>
        </PageHeader>
        <PageContent
          fetching={fetching}
          emptyText="No watches, adjust your filters!"
          emptyTextIcon="svg/growth.svg"
          showEmptyText={!fetching && _.isEmpty(watches)}
          className="watches"
        >
          <Link to={'/admin/watches/add'} className="full-page-add-link offset-page-padding btn-success">
            <div>
              <SVG src="svg/add.svg" className="add mr-2" />
              <span>New Watch</span>
            </div>
            <SVG src="svg/growth.svg" />
          </Link>
          <div className="watches-table">
            <Table>
              <thead>
                <tr>
                  <SortableTH sortField="company.name">Company</SortableTH>
                  <SortableTH sortField="date">Date</SortableTH>
                  <th>Notes</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {_.map(watches, (watch) =>
                  <tr key={watch.id}>
                    <td>
                      <Link to={`/companies/${watch.company}/watches`} className="company-link">
                        <CompanyNickname company={watch.company} noLink />
                      </Link>
                    </td>
                    <td><ShortDate date={watch.date} /></td>
                    <td>{watch.notes}</td>
                    <td className="text-right no-padding options-cell">
                      <Link to={`/companies/${watch.company}/watches/${watch.id}/edit`}>
                        <SVGButton src="svg/edit.svg" title="Edit Watch" />
                      </Link>

                      <SVGButton src="svg/archived.svg" title="Close Watch" onClick={() => this.archiveWatch(watch)} />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
          <Pager count={count} />
        </PageContent>
      </Page>
    );
  }
}

// Exports
export default connect((state) => ({
  watches: state.companies.watches,
  fetching: state.companies.fetching,
  count: state.companies.count,
  query: state.location.query
}))(Watches);



// WEBPACK FOOTER //
// ./app/routes/company/view-watches.js